import React, { useEffect, useRef, useState } from 'react';
import Styles from './CarrosEletricosPremioMobilidadeResultado.css';
import Container from '../../atoms/Container';
import RedButton from '../../atoms/RedButton/RedButton';
import { isBrowser, isMobile } from '../../../utils/browser';
import Accordion from '../../atoms/Accordion';

function CarrosEletricosPremioMobilidadeResultado() {
  const [type, setType] = useState(0);
  const accRef1 = useRef();
  const accRef2 = useRef();
  const accRef3 = useRef();
  const accRef4 = useRef();
  const accRef5 = useRef();
  const accRef6 = useRef();
  const accRef7 = useRef();

  const handleAccChange = (accordion, open) => {
    try {
      if (!open) return;

      switch (accordion) {
        case 1:
          accRef2.current.close();
          accRef3.current.close();
          accRef4.current.close();
          accRef5.current.close();
          accRef6.current.close();
          break;
        case 2:
          accRef1.current.close();
          accRef3.current.close();
          accRef4.current.close();
          accRef5.current.close();
          accRef6.current.close();
          break;
        case 3:
          accRef1.current.close();
          accRef2.current.close();
          accRef4.current.close();
          accRef5.current.close();
          accRef6.current.close();
          break;
        case 4:
          accRef1.current.close();
          accRef2.current.close();
          accRef3.current.close();
          accRef5.current.close();
          accRef6.current.close();
          break;
        case 5:
          accRef1.current.close();
          accRef2.current.close();
          accRef3.current.close();
          accRef4.current.close();
          accRef6.current.close();
          break;
        case 6:
          accRef1.current.close();
          accRef2.current.close();
          accRef3.current.close();
          accRef4.current.close();
          accRef5.current.close();
          break;
        case 7:
          accRef1.current.close();
          accRef2.current.close();
          accRef3.current.close();
          accRef4.current.close();
          accRef5.current.close();
          accRef6.current.close();
          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <section id="carros-eletricos-premio-mobilidade">
        <Container>
          <div className="bloco-titulo">
            <img src="assets/carros-eletricos/premio-resultado/premio-logo.svg" alt="" />
            <div className="textos-titulos">
              <h3 className="premio-titulo">
                O Prêmio Santander pela Mobilidade & Inovação Sustentável reconhece os lojistas e as
                concessionárias que atuam com iniciativas direcionadas ao universo ESG.
              </h3>
              <h4 className="premio-subtitulo">
                Com +170 inscritos, reconhecemos 12 projetos que mais se destacaram, sendo 6 para
                cada uma das duas categorias.
              </h4>
            </div>
          </div>
          <div className="premio-mobilidade-div-btns">
            <span
              className={`premio-mobilidade-btn ${
                type === 0 ? 'selected' : ''
              } premio-mobilidade-btn-1`}
              onClick={() => setType(0)}
            >
              Transformação Social
            </span>
            <span
              className={`premio-mobilidade-btn ${
                type === 1 ? 'selected' : ''
              } premio-mobilidade-btn-2 `}
              onClick={() => setType(1)}
            >
              Iniciativas Sustentáveis e Meio Ambiente
            </span>
          </div>

          <div className="premio-mobilidade-details-div">
            {type === 0 ? (
              <>
                <div className="premio-mobilidade-cards">
                  <div className="premio-mobilidade-cards-div-titulo">
                    <p className="premio-mobilidade-cards-titulo">Lojas</p>
                  </div>
                  <div className="premio-mobilidade-card-container">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-pri-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao  card-primeiropremio-mobilidade-card-colocacao card-primeiro">
                          1º colocado
                        </p>
                        <p className="premio-mobilidade-card-marca">
                          Roni Motors Automóveis Multimarcas LTDA
                        </p>
                        <p className="premio-mobilidade-card-local">
                          FI Baixada Santista (Rede SP Metropolitana)
                        </p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef1}
                      onChange={(open) => {
                        handleAccChange(1, open);
                      }}
                    >
                      <p>
                        Projeto iniciado em 2019, o Grêmio Ronimotors tem como seus pilares o
                        esporte, assistência social e apoio a cultura. Dentre todos os projetos, o
                        principal é o “Jovens da Baixada” , escolinha de futebol que atende 150
                        crianças e adolescentes em vulnerabilidade.
                      </p>
                    </Accordion>
                  </div>
                  <div className="premio-mobilidade-card-container">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-seg-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao card-segundo">2º colocado</p>
                        <p className="premio-mobilidade-card-marca">Graziel Veículos LTDA</p>
                        <p className="premio-mobilidade-card-local">
                          FI SP Leste (Rede SP Metropolitana)
                        </p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef2}
                      onChange={(open) => {
                        handleAccChange(2, open);
                      }}
                    >
                      <p>
                        O Projeto Odonto Esperança, possui como público-alvo crianças de 03 a 11
                        anos em que levam atendimento odontológico através de uma Mini Van adaptada
                        com equipamentos que atendem simultaneamente 02 pacientes com total
                        estrutura e condições de atendimento, com objetivo inicial em profilaxia e
                        aplicação de fluor 02 vezes ao ano a cada criança; Tiveram um investimento
                        inicial de 200 mil reais, e contam com 9 voluntários.
                      </p>
                    </Accordion>
                  </div>
                  <div className="premio-mobilidade-card-container">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-terc-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao card-terceiro">
                          3º colocado
                        </p>
                        <p className="premio-mobilidade-card-marca">Marios Garage LTDA</p>
                        <p className="premio-mobilidade-card-local">FI Blumenau (Rede Sul)</p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef3}
                      onChange={(open) => {
                        handleAccChange(3, open);
                      }}
                    >
                      <p>
                        Desde 2019, o Projeto Encantar é uma ONG que ajuda pessoas e animais em
                        situações vulneráveis. Com 23 empresas apoiadoras, em 2022 atenderam 1105
                        pessoas com entregas de cestas básicas além de campanha na Páscoa, Dia das
                        Crianças e Natal, e em 2023 realizaram 1087 atendimentos.
                      </p>
                    </Accordion>
                  </div>
                </div>
                <div className="premio-mobilidade-cards">
                  <div className="premio-mobilidade-cards-div-titulo">
                    <p className="premio-mobilidade-cards-titulo">Concessionárias</p>
                  </div>
                  <div className="premio-mobilidade-card-container">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-pri-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao card-primeiro">
                          1º colocado
                        </p>
                        <p className="premio-mobilidade-card-marca">
                          Uvel Comercial de Veículos LTDA
                        </p>
                        <p className="premio-mobilidade-card-local">CSS Sul</p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef4}
                      onChange={(open) => {
                        handleAccChange(4, open);
                      }}
                    >
                      <p>
                        O intuito do Projeto é levar para mulheres liberdade emocional, profissional
                        e financeira para que elas se desenvolvam a assumam seus lugares de
                        responsabilidade na sociedade, podendo assim, construir uma comunidade com
                        mais igualdade de gênero, posicionamento feminino e por consequência
                        fomentar a economia regional.
                      </p>
                    </Accordion>
                  </div>
                  <div className="premio-mobilidade-card-container">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-seg-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao card-segundo">2º colocado</p>
                        <p className="premio-mobilidade-card-marca">Atri Comercial LTDA</p>
                        <p className="premio-mobilidade-card-local">CSS SP Interior</p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef5}
                      onChange={(open) => {
                        handleAccChange(5, open);
                      }}
                    >
                      <p>
                        A Atri comercial através da Fundação Amália Vanzella Toniello realiza o
                        programa Jovem Colaborador promovendo mudanças significativas através de
                        ações de qualificação e capacitação ao adolescente, encaminhando ao mercado
                        de trabalho, trazendo a emancipação dos sujeito de direito e de suas
                        famílias em situações de risco e vulnerabilidade.
                      </p>
                    </Accordion>
                  </div>
                  <div className="premio-mobilidade-card-container">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-terc-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao card-terceiro">
                          3º colocado
                        </p>
                        <p className="premio-mobilidade-card-marca">Autonunes LTDA</p>
                        <p className="premio-mobilidade-card-local">CSS Nordeste</p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef6}
                      onChange={(open) => {
                        handleAccChange(6, open);
                      }}
                    >
                      <p>
                        Promove a transformação humana através da Arte-Educação, oferecendo a
                        formação e profissionalização na música e na dança a crianças e jovens em
                        situação de vulnerabilidade social e apoia as famílias desses alunos,
                        oferecendo capacitação em técnicas de artesanato, fomentando o
                        empreendedorismo social.
                      </p>
                    </Accordion>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="premio-mobilidade-cards">
                  <div className="premio-mobilidade-cards-div-titulo">
                    <p className="premio-mobilidade-cards-titulo">Lojas</p>
                  </div>
                  <div className="premio-mobilidade-card-container">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-pri-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao card-primeiro">
                          1º colocado
                        </p>
                        <p className="premio-mobilidade-card-marca">Auto Nível Veículos LDTA</p>
                        <p className="premio-mobilidade-card-local">
                          FI SP Leste (Rede SP Metropolitana)
                        </p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef1}
                      onChange={(open) => {
                        handleAccChange(1, open);
                      }}
                    >
                      <p>
                        Redução de 20kg de CO2 anualmente. Além disso também possuem posto de
                        carregamento de veículos elétricos e um olhar para o pilar social,
                        investindo R$200.000,00 na revitalização de três quarteirões da Avenida
                        Furtado, em parceria com empresas locais.
                      </p>
                    </Accordion>
                  </div>
                  <div className="premio-mobilidade-card-container">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-seg-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao card-segundo">2º colocado</p>
                        <p className="premio-mobilidade-card-marca">Auto Shopping Global</p>
                        <p className="premio-mobilidade-card-local">
                          FI SP ABC (Rede SP Metropolitana)
                        </p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef2}
                      onChange={(open) => {
                        handleAccChange(2, open);
                      }}
                    >
                      <p>
                        O AutoShopping Global é o primeiro shopping de veículos do Brasil a
                        implantar o sistema de reaproveitamento de água da chuva. Além disso,
                        trocaram à caldeira a gás por sistema de aquecimento solar, onde conseguem
                        obter uma redução média de 2.488 tCO2/ ano (18 arvores) e instalaram um
                        posto de carregamento de veículos elétricos.
                      </p>
                    </Accordion>
                  </div>
                  <div className="premio-mobilidade-card-container">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-terc-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao card-terceiro">
                          3º colocado
                        </p>
                        <p className="premio-mobilidade-card-marca">Attra Veículos Multimarcas</p>
                        <p className="premio-mobilidade-card-local">
                          FI Triangulo Mineiro (Rede Sudeste)
                        </p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef3}
                      onChange={(open) => {
                        handleAccChange(3, open);
                      }}
                    >
                      <p>
                        Desde 2017 a loja possui comprometimento com economia circular e de baixo
                        carbono e diversidade e inclusão. Utilizam energia solar como fonte de
                        eletricidade para as duas unidades e incentivam a venda de carros elétricos
                        e híbridos oferecendo um posto de carregamento de veículos elétricos.
                      </p>
                    </Accordion>
                  </div>
                </div>
                <div className="premio-mobilidade-cards">
                  <div className="premio-mobilidade-cards-div-titulo">
                    <p className="premio-mobilidade-cards-titulo">Concessionárias</p>
                  </div>
                  <div className="premio-mobilidade-card-container card-concessionario">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-pri-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao card-primeiro">
                          1º colocado
                        </p>
                        <p className="premio-mobilidade-card-marca">McLarty Maia</p>
                        <p className="premio-mobilidade-card-local">CSS SP Capital</p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef4}
                      onChange={(open) => {
                        handleAccChange(4, open);
                      }}
                    >
                      <p>
                        O Projeto Costurando Futuro faz parte do Pilar Repense, é uma iniciativa que
                        surgiu em 2021, com foco na reciclagem dos uniformes dos colaboradores para
                        a produção de cobertores destinados à doação. Em 2023 foram destinados 144
                        kg de uniformes (453 peças), evitando que esses materiais fossem enviados a
                        aterros sanitários. Além disso buscam sensibilizar e engajar stakeholders
                        internos e externos para criarem impacto social e ambiental positivo.
                      </p>
                    </Accordion>
                  </div>
                  <div className="premio-mobilidade-card-container">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-seg-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao card-segundo">2º colocado</p>
                        <p className="premio-mobilidade-card-marca">
                          Platinum automóveis importados LTDA
                        </p>
                        <p className="premio-mobilidade-card-local">CSS SP Interior</p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef5}
                      onChange={(open) => {
                        handleAccChange(5, open);
                      }}
                    >
                      <p>
                        Com início em 2020, o projeto Osten Consciente possui um calendário de ações
                        mapeadas para os próximos 5 anos. Com usina de energia fotovoltaica própria,
                        conseguiram evitar 270,16 t de CO2 em quase dois anos. Realizam a captação
                        de água pluvial para reuso, logística reversa dos resíduos e possuem
                        estações de carregamento de veículos elétricos.
                      </p>
                    </Accordion>
                  </div>
                  <div className="premio-mobilidade-card-container">
                    <div className="premio-mobilidade-card-main">
                      <img
                        src="assets/carros-eletricos/premio-resultado/premio-terc-colocado.svg"
                        alt=""
                      />
                      <div className="premio-mobilidade-card-1">
                        <p className="premio-mobilidade-card-colocacao card-terceiro">
                          3º colocado
                        </p>
                        <p className="premio-mobilidade-card-marca">Empresas Revemar</p>
                        <p className="premio-mobilidade-card-local">CSS Norte</p>
                      </div>
                    </div>
                    <Accordion
                      bottomSpace={false}
                      dividerUp={true}
                      title="Mais detalhes"
                      accordionRef={accRef6}
                      onChange={(open) => {
                        handleAccChange(6, open);
                      }}
                    >
                      <p>
                        O Projeto Direção Sustentável no Descarte Consciente faz parte dos 5 pilares
                        de atuação do Grupo (Meio Ambiente, Social, Governança e Segurança) e tem
                        como objetivo destinar de forma adequada todos os resíduos gerados em nossas
                        lojas.
                      </p>
                    </Accordion>
                  </div>
                </div>
              </>
            )}
          </div>
        </Container>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosPremioMobilidadeResultado;
